import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { TooltipDirective } from '@shared/directives/tooltip.directive';

import {
  BudgetCompareMenuSnapshotChangeFn,
  BudgetCompareMenuSnapshotDisabled,
  BudgetCompareMenuSnapshotFormControl,
  BudgetCompareMenuSnapshotList,
  BudgetCompareMenuSnapshotLoading,
  BudgetCompareMenuSnapshotRefreshFn,
  BudgetCompareMenuSnapshotShowDelete,
  BudgetCompareMenuSnapshotShowEdit,
  BudgetCompareMenuSnapshotValue,
  defaultSnapshotChangeFn,
  defaultSnapshotRefreshFn,
} from '../../models/budget-compare-menu.models';
import { CompareDropdownComponent } from '../compare-dropdown-trial-insights/compare-dropdown.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, CompareDropdownComponent],
  selector: 'aux-budget-compare-menu-snapshot',
  templateUrl: './budget-compare-menu-snapshot.component.html',
})
export class BudgetCompareMenuSnapshotComponent {
  @Input() snapshotChangeFn: BudgetCompareMenuSnapshotChangeFn;
  @Input() snapshotDisabled: BudgetCompareMenuSnapshotDisabled;
  @Input() snapshotFormControl: BudgetCompareMenuSnapshotFormControl;
  @Input() snapshotList: BudgetCompareMenuSnapshotList;
  @Input() snapshotLoading: BudgetCompareMenuSnapshotLoading;
  @Input() snapshotRefreshFn: BudgetCompareMenuSnapshotRefreshFn;
  @Input() snapshotShowDelete: BudgetCompareMenuSnapshotShowDelete;
  @Input() snapshotShowEdit: BudgetCompareMenuSnapshotShowEdit;
  @Input() snapshotValue: BudgetCompareMenuSnapshotValue;
  tooltip = 'Comparing to a snapshot is only supported in Vendor Contract Currency';

  constructor() {
    this.snapshotFormControl = new FormControl<string>('');
    this.snapshotList = [];
    this.snapshotValue = '';
    this.snapshotDisabled = false;
    this.snapshotShowEdit = true;
    this.snapshotShowDelete = true;
    this.snapshotLoading = false;
    this.snapshotChangeFn = defaultSnapshotChangeFn;
    this.snapshotRefreshFn = defaultSnapshotRefreshFn;
  }
}
